import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ProductionJobComponent } from './production-job/production-job.component';
import { DiscoveryRoutingModule } from './discovery-routing.module';
import { ProductionJobDetailsComponent } from './production-job-details/production-job-details.component';
import { RunProductionDialogComponent } from './dialogs/run-production-dialog/run-production-dialog.component';
import { OperationsProductionDownloadDialogComponent } from './dialogs/operations-production-download-dialog/operations-production-download-dialog.component';
import { DownloadProductionDialogComponent } from './dialogs/download-production-dialog/download-production-dialog.component';
import { CreateProductionJobComponent } from './create-production-job/create-production-job.component';
import { ProductionValidationComponent } from './production-validation/production-validation.component';
import { ReviewSetsComponent } from './review-sets/review-sets.component';
import { ModifyReviewSetDialogComponent } from './review-sets/create-review-set-dialog/modify-review-set-dialog.component';
import { ReviewTrackingComponent } from './review-tracking/review-tracking.component';
import { LineChartModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../shared.module';
import { MatSortModule } from '@angular/material/sort';
import { MaterialModule } from '../../core/material/material.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProductionWithheldLogDialogComponent } from './dialogs/production-withheld-log-dialog/production-withheld-log-dialog.component';
import { DownloadProductionWithheldDialogComponent } from './dialogs/download-production-withheld-dialog/download-production-withheld-dialog.component';
import { AiReviewComponent } from './ai-review/ai-review.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedProductionDownloadSettingsComponent } from './dialogs/shared-production-downloads/shared-production-download-settings.component';
import { ProductionJobAuditLogComponent } from './dialogs/production-job-audit-log/production-job-audit-log.component';
import { SplitReviewSetComponent } from './review-sets/split-review-set/split-review-set.component';

@NgModule({
	declarations: [
		ProductionJobComponent,
		ProductionJobDetailsComponent,
		RunProductionDialogComponent,
		OperationsProductionDownloadDialogComponent,
		DownloadProductionDialogComponent,
		CreateProductionJobComponent,
		ProductionValidationComponent,
		ReviewSetsComponent,
		ModifyReviewSetDialogComponent,
		ReviewTrackingComponent,
		ProductionWithheldLogDialogComponent,
		DownloadProductionWithheldDialogComponent,
		AiReviewComponent,
		SharedProductionDownloadSettingsComponent,
		ProductionJobAuditLogComponent,
		SplitReviewSetComponent
	],
	imports: [
		CommonModule,
		DiscoveryRoutingModule,
		MaterialModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
		ClipboardModule,
		LineChartModule,
		SharedModule,
		MatSortModule,
		NgxSkeletonLoaderModule,
		NgxChartsModule
	]
})
export class DiscoveryModule {
}
